import type { SlideDef } from "@/engine/types";
import { OnPageAnatomySlide } from "./01-onpage-anatomy";
import { OnPageChecklistSlide } from "./02-onpage-checklist";

export const slides: SlideDef[] = [
  {
    id: "c2-onpage-anatomy",
    chapter: 2,
    title: "Demo: On-page anatomy",
    component: OnPageAnatomySlide,
  },
  {
    id: "c2-onpage-checklist",
    chapter: 2,
    title: "On-page checklist",
    component: OnPageChecklistSlide,
  },
];
